import { HttpRequest } from '../../lib/http';
import { API } from './constant';

export const action = async (): Promise<any> => {
  return HttpRequest({
    method: API.TYPE,
    url: API.URL,
  });
};
